import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-solucoes',
  templateUrl: './solucoes.component.html'
})
export class SolucoesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
